import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { HelperDataService } from 'src/app/modules/acbcr/common/services/helper-data.service';
import { RapoarteFacturiEmiseTableService } from 'src/app/modules/acbcr/common/services/rapoarte-facturi-emise.service';

@Component({
  selector: 'app-raport-facturi-emise',
  templateUrl: './raport-facturi-emise.component.html',
  styleUrls: ['./raport-facturi-emise.component.scss']
})
export class RaportFacturiEmiseComponent implements OnInit {

  tables$: Observable<any[]>;
  total$: Observable<number>;
  loadingDataSpinner = false;

  objToAPI = {
    tip: null,
    page_no: '1',
    page_size: '10'
  };

  constructor(
    public rapoarteFacturiEmise: RapoarteFacturiEmiseTableService,
    public helperDataService: HelperDataService
  ) {
    this.tables$ = rapoarteFacturiEmise.tables$;
    this.total$ = rapoarteFacturiEmise.total$;
  }

  ngOnInit(): void {
    this.getTableData();
  }

  getTableData() {
    this.loadingDataSpinner = true;
    this.rapoarteFacturiEmise
      .getRapoarteFacturiemiseAPI(this.objToAPI).subscribe((response) => {
        setTimeout(() => {
          this.loadingDataSpinner = false;
        }, 500);
      });
  }

  filterSearchData(event) {
    this.objToAPI = {
      ...this.objToAPI,
      ...event,
    };
    this.getTableData();
  }

  exportData(event) {
    this.rapoarteFacturiEmise
      .exportXLS(this.objToAPI)
      .subscribe((response) => {
        const blob = new Blob([response], { type: 'application/octet-stream' });
        this.helperDataService.simulateDownload( blob, `Rapoarte-facturi-emise.xls`);
      });
  }

  changePageSize(event) {
    this.objToAPI.page_size = event;
    this.getTableData();
  }

  changePageNumber(event) {
    this.objToAPI.page_no = event;
    this.getTableData();
  }

}
